import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Style.
 */

const StyledSpacerDiv = styled.div`
  flex-grow: 1;
`;

/*
 * Component.
 */

/**
 * Take up the free space available between buttons in a group.
 * @see {@link ButtonGroup} for how it applies different styling to this child than others.
 */
export const ButtonGroupSpacer: FC = () => <StyledSpacerDiv />;
